import React from "react";
import { QRCodeSVG } from "qrcode.react";

/** QR 코드 with URL — 재사용 가능 */
export default function PageQR({ url, size = 64 }) {
  if (!url) return null;
  return (
    <div className="flex flex-col items-center gap-1">
      <QRCodeSVG value={url} size={size} level="M" includeMargin={false} />
      <p className="text-[8px] text-[#86868b] max-w-[80px] text-center truncate">{url.replace(/^https?:\/\//, '')}</p>
    </div>
  );
}

